import React, { Component, Fragment } from 'react';
import { Row, Col, Input, Label, Button, Table } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faTrashAlt, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import PermissionWrapper from '../../auth/PermissionWrapper';
import ReactDragListView from 'react-drag-listview';
import ConfirmButton from '../Modal/ConfirmButton';

class BOTManagementForm extends Component {

    formatDate = (d) => {
        if (parseInt(String(d).substring(0, 4)) <= 2000) return "";
        return parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10)) + '/' + parseInt(String(d).substring(0, 4));
    }


    // Function to format the date in "h:mm am/pm" format
    formatTime = (ISOstring) => {
        const date = new Date(ISOstring);
        const options = {
            timeZone: 'UTC',
            hour12: true,
            hour: 'numeric',
            minute: '2-digit'
        };
        return date.toLocaleTimeString('en-US', options);
    }

    checkPermission = (permission) => {
        this.props.info('BOTManagementForm.js/checkPermission (permission)', permission);
        const permissionGranted =
            permission === '' || permission == null ||
            this.props.userPermissions.findIndex(i => i.toUpperCase() === permission.toUpperCase()) > -1;
        return permissionGranted;
    }

    standardRow = (requestTicket) => {
        this.props.info('BOTManagementForm.js/standardRow (requestTicket)', requestTicket);
        return (
            <tr className={"adminRow pointer widgetRow bot text-left"} onClick={() => this.props.onEdit(requestTicket.id)}>
                {(this.props.singleEmployee == null || !this.props.singleEmployee) && <td className={((!requestTicket.employeeActive && requestTicket.lastName != null) ? "text-danger" : "")}>{requestTicket.lastName}, {requestTicket.firstName}</td>}
                <td className={((!requestTicket.assignedActive && requestTicket.assignedLastName != null) ? "text-danger" : "")}><div className="ref" ref={this.props.botRefs.filter(ref => ref.id === requestTicket.id)[0].ref}></div>{requestTicket.assignedLastName}{requestTicket.assignedLastName != null ? ', ' : ''}{requestTicket.assignedFirstName}</td>
                {(this.props.singleEmployee == null || !this.props.singleEmployee) && <td>{requestTicket.teamName}</td>}
                <td className='wrap'>{requestTicket.clientName}</td>
                <td className='wrap'>{requestTicket.requestId === 4 ? requestTicket.requestOther : this.props.requests.filter(item => item.key === requestTicket.requestId)[0].value}</td>
                <td>{requestTicket.priorityId > 0 ? this.props.priorities.filter(item => item.key === requestTicket.priorityId)[0].value : ''}</td>
                <td>{requestTicket.timeSavedEstimate} {requestTicket.timeSavedEstimate != null && requestTicket.timeSavedEstimate !== '' && 'h'}</td>
                <td>{requestTicket.timeEstimate} {requestTicket.timeEstimate != null && requestTicket.timeEstimate !== '' && 'h'}</td>
                <td className="dragIcon">{requestTicket.priorityRankId > 0 ? `${this.props.priorityRanks.filter(item => item.key === requestTicket.priorityRankId)[0].value} ` : 'Not Set'}{requestTicket.order > 0 && this.props.selectedSortColumnIndex === 8 ? ` (${(requestTicket.order - (requestTicket.priorityRankId * 0)) / 10})` : ''}</td>
                <td>{requestTicket.applicationName} {requestTicket.version != null && requestTicket.version !== '' ? `(v${requestTicket.version})` : ''}</td>
            </tr>
        )
    }

    editRow = (requestTicket) => {
        this.props.log('BOTManagementForm.js/editRow (requestTicket)', requestTicket);
        let clients = this.props.clients;
        if (this.props.singleEmployee && !this.checkPermission('Show All Clients')) {
            const allEmployeeClients = (this.props.userEmployee.primaryCustomers != null ? this.props.userEmployee.primaryCustomers : [])
                .concat(this.props.userEmployee.secondaryCustomers != null ? this.props.userEmployee.secondaryCustomers : [])
                .concat(this.props.userEmployee.teamCustomers != null ? this.props.userEmployee.teamCustomers : [])
                .map(client => client.clientId);
            clients = clients.filter(client => allEmployeeClients.findIndex(employeeClient => employeeClient === client.id) > -1);
        }
        return (<tr>
            <td colSpan={9}>
                <div className="ref" ref={this.props.botRefs.filter(ref => ref.id === requestTicket.id)[0].ref}></div>
                <Row className="adminRow activeTab text-left align-top">
                    <Col md={4}>
                        {(this.props.singleEmployee == null || !this.props.singleEmployee) && <Row>
                            <Col md={4}>Employee</Col>
                            <Col>
                                <Input
                                    type="select"
                                    name="employeeId"
                                    value={this.props.isFieldNull(this.props.editRequestTicket.employeeId)}
                                    onChange={e => this.props.onChange(e, 'edit')} >
                                    <option value={0}>SELECT EMPLOYEE</option>
                                    {this.props.employees.map(employee => (
                                        <option key={employee.employeeId} value={this.props.isFieldNull(employee.employeeId)}>{employee.lastName}, {employee.firstName} </option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>}
                        {(this.props.singleEmployee == null || !this.props.singleEmployee) && <Row>
                            <Col md={4}>Team</Col>
                            <Col>
                                <Input type="select"
                                    name="teamId"
                                    onChange={(e) => this.props.onChange(e, 'edit')}
                                    value={this.props.isFieldNull(this.props.editRequestTicket.teamId)}
                                >
                                    <option value="0">SELECT TEAM</option>
                                    {this.props.teams.map(team => (
                                        <option key={team.id}
                                            value={this.props.isFieldNull(team.id)}>{team.id === -1 ? 'Team Not Set' : team.teamName}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>}
                        <Row>
                            <Col md={4}>Client</Col>
                            <Col>
                                <Input type="select"
                                    name="clientId"
                                    onChange={(e) => this.props.onChange(e, 'edit')}
                                    value={this.props.isFieldNull(this.props.editRequestTicket.clientId)}
                                >
                                    <option value="0">SELECT CLIENT</option>
                                    {clients.map(client => (
                                        <option key={client.id}
                                            value={this.props.isFieldNull(client.id)}>{client.client}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>Request Category</Col>
                            <Col>
                                <Input
                                    type="select"
                                    name="requestId"
                                    value={this.props.isFieldNull(this.props.editRequestTicket.requestId)}
                                    onChange={e => { this.props.onChange(e, 'edit'); this.props.onChange({ persist: function () { }, target: { name: 'requestOther', value: '' } }) }} >
                                    <option value={0}>SELECT REQUEST CATEGORY</option>
                                    {this.props.requests.map(request => (
                                        <option key={request.key} value={this.props.isFieldNull(request.key)}>{request.value}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>
                        {parseInt(this.props.newRequestTicket.requestId) === 4 && <Row>
                            <Col md={4}></Col>
                            <Col>
                                <Input
                                    placeholder="Enter Custom Category"
                                    type="text"
                                    name="requestOther"
                                    value={this.props.isFieldNull(this.props.editRequestTicket.requestOther)}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                            </Col>
                        </Row>}
                        <Row>
                            <Col md={4}>Connectivity</Col>
                            <Col>
                                <Input
                                    placeholder="Connectivity Category"
                                    type="text"
                                    name="connectivityOther"
                                    value={this.props.isFieldNull(this.props.editRequestTicket.connectivityOther)}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>Requestor Priority</Col>
                            <Col>
                                <Input
                                    type="select"
                                    name="priorityId"
                                    value={this.props.isFieldNull(this.props.editRequestTicket.priorityId)}
                                    onChange={e => this.props.onChange(e, 'edit')} >
                                    <option value={0}>SELECT PRIORITY</option>
                                    {this.props.priorities.map(priority => (
                                        <option key={priority.key} value={this.props.isFieldNull(priority.key)}>{priority.value}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>Estimated Time Saved<br /><span className="pl-2">(in hours) for each event</span></Col>
                            <Col>
                                <Input
                                    type="number"
                                    name="timeSavedEstimate"
                                    value={this.props.isFieldNull(this.props.editRequestTicket.timeSavedEstimate)}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>Client Directed</Col>
                            <Col>
                                <Label className='mr-4'>Yes
                                    <Input
                                        className='ml-2'
                                        type="radio"
                                        name="clientDirected-edit"
                                        checked={this.props.isFieldNull(this.props.editRequestTicket.clientDirected)}
                                        value={true}
                                        onChange={e => this.props.onChange(e, 'edit')} />
                                </Label>
                                <Label className='ml-4'>No
                                    <Input
                                        className="ml-2"
                                        type="radio"
                                        name="clientDirected-edit"
                                        checked={!this.props.isFieldNull(this.props.editRequestTicket.clientDirected)}
                                        value={false}
                                        onChange={e => this.props.onChange(e, 'edit')} />
                                </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}></Col>
                            <Col className='font-italic'>
                                {this.props.editRequestTicket.clientDirected != null && this.props.editRequestTicket.clientDirected && <Label className='ml-1'>Customer has asked for this functionality</Label>}
                                {this.props.editRequestTicket.clientDirected != null && !this.props.editRequestTicket.clientDirected && <Label className='ml-1'>BO has asked for this to increase productivity and accuracy</Label>}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>Notes<br /><span className="pl-2">(specific details of request)</span></Col>
                            <Col>
                                <Input
                                    type="textarea"
                                    rows={6}
                                    name="notes"
                                    value={this.props.isFieldNull(this.props.editRequestTicket.notes)}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                            </Col>
                        </Row>
                    </Col>
                    <Col md={4} className="text-right">
                        <Row>
                            <Col md={4}>Status</Col>
                            <Col className='text-left'>
                                {(this.props.singleEmployee == null || !this.props.singleEmployee) ? <Input
                                    type="select"
                                    name="statusId"
                                    value={this.props.isFieldNull(this.props.editRequestTicket.statusId)}
                                    onChange={e => { this.props.onChange(e, 'edit'); this.props.onChange({ persist: function () { }, target: { name: 'statusId', value: '' } }) }} >
                                    <option value={0}>SELECT STATUS</option>
                                    {this.props.statuses.map(request => (
                                        <option key={request.key} value={this.props.isFieldNull(request.key)}>{request.value}</option>
                                    ))}
                                </Input> : this.props.editRequestTicket.statusId != null ? (this.props.statuses.filter(status => parseInt(status.key) === parseInt(this.props.editRequestTicket.statusId))[0].value) : ''}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>Assigned To</Col>
                            <Col className='text-left'>
                                {(this.props.singleEmployee == null || !this.props.singleEmployee) ? <Input
                                    type="select"
                                    name="assignedEmployeeId"
                                    value={this.props.isFieldNull(this.props.editRequestTicket.assignedEmployeeId)}
                                    onChange={e => this.props.onChange(e, 'edit')} >
                                    <option value={0}>SELECT EMPLOYEE</option>
                                    {this.props.employees.map(employee => (
                                        <option key={employee.employeeId} value={this.props.isFieldNull(employee.employeeId)}>{employee.lastName}, {employee.firstName} </option>
                                    ))}
                                </Input> : this.props.editRequestTicket.assignedEmployeeId != null ? (this.props.employees.filter(employee => parseInt(employee.employeeId) === parseInt(this.props.editRequestTicket.assignedEmployeeId))[0].lastName + ', ' + this.props.employees.filter(employee => parseInt(employee.employeeId) === parseInt(this.props.editRequestTicket.assignedEmployeeId))[0].firstName) : ""}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>Ranking System for Priority</Col>
                            <Col className='text-left'>
                                {(this.props.singleEmployee == null || !this.props.singleEmployee) ? <Input
                                    type="select"
                                    name="priorityRankId"
                                    value={this.props.isFieldNull(this.props.editRequestTicket.priorityRankId)}
                                    onChange={e => this.props.onChange(e, 'edit')} >
                                    <option value={0}>SELECT PRIORITY RANK</option>
                                    {this.props.priorityRanks.map(priority => (
                                        <option key={priority.key} value={this.props.isFieldNull(priority.key)}>{priority.value}</option>
                                    ))}
                                </Input> : this.props.editRequestTicket.priorityRankId != null ? (this.props.priorityRanks.filter(priority => parseInt(priority.key) === parseInt(this.props.editRequestTicket.priorityRankId))[0].value) : ""}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>Time Estimate</Col>
                            <Col className='text-left'>
                                {(this.props.singleEmployee == null || !this.props.singleEmployee) ? <Input
                                    type="number"
                                    name="timeEstimate"
                                    value={this.props.isFieldNull(this.props.editRequestTicket.timeEstimate)}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                                    : this.props.editRequestTicket.timeEstimate}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>Update Notes</Col>
                            <Col className='text-left'>
                                {(this.props.singleEmployee == null || !this.props.singleEmployee) ? <Input
                                    type="textarea"
                                    rows={6}
                                    name="updateNotes"
                                    value={this.props.isFieldNull(this.props.editRequestTicket.updateNotes)}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                                    : this.props.editRequestTicket.updateNotes}
                            </Col>
                        </Row>
                        <Row className='mt-5 mb-2'>
                            <Col className='text-center'><strong>Management Section</strong></Col>
                        </Row>
                        <Row>
                            <Col md={4}>Date Completed</Col>
                            <Col className='text-left'>
                                {(this.props.singleEmployee == null || !this.props.singleEmployee) ?
                                    <Input
                                        type="date"
                                        rows={6}
                                        name="completed"
                                        value={String(this.props.isFieldNull(this.props.editRequestTicket.completed)).substring(0, 10)}
                                        onChange={e => this.props.onChange(e, 'edit')} />
                                    : this.props.editRequestTicket.completed != null ? this.formatDate(String(this.props.editRequestTicket.completed).substring(0, 10)) : ""}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>Project Type</Col>
                            <Col className='text-left'>
                                {(this.props.singleEmployee == null || !this.props.singleEmployee) ? <Input
                                    type="select"
                                    name="projectType"
                                    disabled={parseInt(this.props.editRequestTicket.technologyStatus) !== 1}
                                    value={this.props.isFieldNull(this.props.editRequestTicket.projectType)}
                                    onChange={e => this.props.onChange(e, 'edit')} >
                                    <option value={0}>SELECT PROJECT TYPE</option>
                                    {this.props.projectTypes.map(projectType => (
                                        <option key={projectType.key} value={this.props.isFieldNull(projectType.key)}>{projectType.value}</option>
                                    ))}
                                </Input> : this.props.editRequestTicket.projectType != null ? (this.props.projectTypes.filter(projectType => parseInt(projectType.key) === parseInt(this.props.editRequestTicket.projectType))[0].value) : ""}
                            </Col>
                        </Row>
                    </Col>
                    <Col md={4} className="text-right">
                        <Row>
                            <Col md={4}>Tech Status</Col>
                            <Col className='text-left'>
                                {(this.props.singleEmployee == null || !this.props.singleEmployee) ? <Input
                                    type="select"
                                    name="technologyStatus"
                                    value={this.props.isFieldNull(this.props.editRequestTicket.technologyStatus)}
                                    onChange={e => this.props.onChange(e, 'edit')} >
                                    <option value={0}>SELECT TECH STATUS</option>
                                    {this.props.technologyStatuses.map(technologyStatus => (
                                        <option key={technologyStatus.key} value={this.props.isFieldNull(technologyStatus.key)}>{technologyStatus.value}</option>
                                    ))}
                                </Input> : this.props.editRequestTicket.technologyStatus != null ? (this.props.technologyStatuses.filter(technologyStatus => parseInt(technologyStatus.key) === parseInt(this.props.editRequestTicket.technologyStatus))[0].value) : ""}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>Version</Col>
                            <Col>
                                <Input
                                    placeholder="Version #"
                                    type="text"
                                    name="version"
                                    value={this.props.isFieldNull(this.props.editRequestTicket.version)}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>Application Name</Col>
                            <Col>
                                <Input
                                    placeholder="Application Name"
                                    type="text"
                                    name="applicationName"
                                    value={this.props.isFieldNull(this.props.editRequestTicket.applicationName)}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>Application Type</Col>
                            <Col className='text-left'>
                                {(this.props.singleEmployee == null || !this.props.singleEmployee) ? <Input
                                    type="select"
                                    name="applicationType"
                                    value={this.props.isFieldNull(this.props.editRequestTicket.applicationType)}
                                    onChange={e => this.props.onChange(e, 'edit')} >
                                    <option value={0}>SELECT APPLICATION TYPE</option>
                                    {this.props.applicationTypes.map(applicationType => (
                                        <option key={applicationType.key} value={this.props.isFieldNull(applicationType.key)}>{applicationType.value}</option>
                                    ))}
                                </Input> : this.props.editRequestTicket.applicationType != null ? (this.props.applicationTypes.filter(applicationType => parseInt(applicationType.key) === parseInt(this.props.editRequestTicket.applicationType))[0].value) : ""}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>Tech Notes</Col>
                            <Col>
                                <Input
                                    type="textarea"
                                    rows={6}
                                    name="technologyNotes"
                                    value={this.props.isFieldNull(this.props.editRequestTicket.technologyNotes)}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>Clients Using</Col>
                            <Col className='p-3 pl-5 maxHpanel'>
                                {[...this.props.clients]
                                    .map(client => (
                                        <Row key={client.id}>
                                            <Label for={"botClients_" + client.id}>
                                                <Input
                                                    type="checkbox"
                                                    name="botClients"
                                                    id={"botClients_" + client.id}
                                                    checked={this.props.isFieldNull(this.props.editRequestTicket.clientsUsing.findIndex(i => i.id === parseInt(client.id)) > -1, true)}
                                                    onChange={e => this.props.onChange(e, 'edit')}
                                                />{client.client}
                                            </Label>
                                        </Row>
                                    ))}
                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Col>

                            </Col>
                        </Row>
                    </Col>
                    <Col md={8}>
                        Submitted {this.formatDate(String(this.props.editRequestTicket.timestamp).substring(0, 10))} {this.formatTime(String(this.props.editRequestTicket.timestamp))}
                    </Col>
                    <Col md={4} className='text-right'>
                        <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Request Tickets">
                            <Button
                                disabled={parseInt(this.props.editRequestTicket.employeeId) === 0 ||
                                    parseInt(this.props.editRequestTicket.teamId) === 0 ||
                                    parseInt(this.props.editRequestTicket.clientId) === 0 ||
                                    parseInt(this.props.editRequestTicket.requestId) === 0
                                }
                                color="success"
                                title="Save Request Ticket"
                                onClick={this.props.handleEdit}
                            >
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                        </PermissionWrapper>
                        <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Delete Request Ticket">
                            <ConfirmButton className="mx-1" color="danger" onClick={() => this.props.onDelete(this.props.botRequestTicketId)} title="Delete Request Ticket">
                                <FontAwesomeIcon icon={faTrashAlt} />
                            </ConfirmButton>
                        </PermissionWrapper>
                        <Button
                            color="secondary"
                            title="Cancel"
                            onClick={this.props.handleCancel}
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </Button>
                    </Col>

                </Row>
            </td></tr>
        )
    }

    // addRow = () => {
    //     this.props.info('BOTManagementForm.js/addRow');
    //     let clients = this.props.clients;
    //     if (this.props.singleEmployee && !this.checkPermission('Show All Clients')) {
    //         const allEmployeeClients = (this.props.userEmployee.primaryCustomers != null ? this.props.userEmployee.primaryCustomers : [])
    //             .concat(this.props.userEmployee.secondaryCustomers != null ? this.props.userEmployee.secondaryCustomers : [])
    //             .concat(this.props.userEmployee.teamCustomers != null ? this.props.userEmployee.teamCustomers : [])
    //             .map(client => client.clientId);
    //         clients = clients.filter(client => allEmployeeClients.findIndex(employeeClient => employeeClient === client.id) > -1);
    //     }
    //     return (<tr><td colSpan={8}>
    //         <Row className="py-4 text-left align-top ">
    //             <Col md={6}>
    //                 {(this.props.singleEmployee == null || !this.props.singleEmployee) && <Row>
    //                     <Col md={4}>Employee</Col>
    //                     <Col>
    //                         <Input
    //                             type="select"
    //                             name="employeeId"
    //                             value={this.props.isFieldNull(this.props.newRequestTicket.employeeId)}
    //                             onChange={e => this.props.onChange(e)} >
    //                             <option value={0}>SELECT EMPLOYEE</option>
    //                             {this.props.employees.map(employee => (
    //                                 <option key={employee.employeeId} value={this.props.isFieldNull(employee.employeeId)}>{employee.lastName}, {employee.firstName} </option>
    //                             ))}
    //                         </Input>
    //                     </Col>
    //                 </Row>}
    //                 {(this.props.singleEmployee == null || !this.props.singleEmployee) && <Row>
    //                     <Col md={4}>Team</Col>
    //                     <Col>
    //                         <Input type="select"
    //                             name="teamId"
    //                             onChange={(e) => this.props.onChange(e)}
    //                             value={this.props.isFieldNull(this.props.newRequestTicket.teamId)}
    //                         >
    //                             <option value="0">SELECT TEAM</option>
    //                             {this.props.teams.map(team => (
    //                                 <option key={team.id}
    //                                     value={this.props.isFieldNull(team.id)}>{team.id === -1 ? 'Team Not Set' : team.teamName}</option>
    //                             ))}
    //                         </Input>
    //                     </Col>
    //                 </Row>}
    //                 <Row>
    //                     <Col md={4}>Client</Col>
    //                     <Col>
    //                         <Input type="select"
    //                             name="clientId"
    //                             onChange={(e) => this.props.onChange(e)}
    //                             value={this.props.isFieldNull(this.props.newRequestTicket.clientId)}
    //                         >
    //                             <option value="0">SELECT CLIENT</option>
    //                             {clients.map(client => (
    //                                 <option key={client.id}
    //                                     value={this.props.isFieldNull(client.id)}>{client.client}</option>
    //                             ))}
    //                         </Input>
    //                     </Col>
    //                 </Row>
    //                 <Row>
    //                     <Col md={4}>Request Category</Col>
    //                     <Col>
    //                         <Input
    //                             type="select"
    //                             name="requestId"
    //                             value={this.props.isFieldNull(this.props.newRequestTicket.requestId)}
    //                             onChange={e => { this.props.onChange(e); this.props.onChange({ persist: function () { }, target: { name: 'requestOther', value: '' } }) }} >
    //                             <option value={0}>SELECT REQUEST CATEGORY</option>
    //                             {this.props.requests.map(request => (
    //                                 <option key={request.key} value={this.props.isFieldNull(request.key)}>{request.value}</option>
    //                             ))}
    //                         </Input>
    //                     </Col>
    //                 </Row>
    //                 {parseInt(this.props.newRequestTicket.requestId) === 4 && <Row>
    //                     <Col md={4}></Col>
    //                     <Col>
    //                         <Input
    //                             placeholder="Enter Custom Category"
    //                             type="text"
    //                             name="requestOther"
    //                             value={this.props.isFieldNull(this.props.newRequestTicket.requestOther)}
    //                             onChange={e => this.props.onChange(e)} />
    //                     </Col>
    //                 </Row>}
    //                 <Row>
    //                     <Col md={4}>Connectivity</Col>
    //                     <Col>
    //                         <Input
    //                             placeholder="Connectivity Category"
    //                             type="text"
    //                             name="connectivityOther"
    //                             value={this.props.isFieldNull(this.props.newRequestTicket.connectivityOther)}
    //                             onChange={e => this.props.onChange(e)} />
    //                     </Col>
    //                 </Row>
    //                 <Row>
    //                     <Col md={4}>Requestor Priority</Col>
    //                     <Col>
    //                         <Input
    //                             type="select"
    //                             name="priorityId"
    //                             value={this.props.isFieldNull(this.props.newRequestTicket.priorityId)}
    //                             onChange={e => this.props.onChange(e)} >
    //                             <option value={0}>SELECT PRIORITY</option>
    //                             {this.props.priorities.map(priority => (
    //                                 <option key={priority.key} value={this.props.isFieldNull(priority.key)}>{priority.value}</option>
    //                             ))}
    //                         </Input>
    //                     </Col>
    //                 </Row>
    //                 <Row>
    //                     <Col md={4}>Estimated Time Saved<br /><span className="pl-2">(in hours) for each event</span></Col>
    //                     <Col>
    //                         <Input
    //                             type="number"
    //                             name="timeSavedEstimate"
    //                             value={this.props.isFieldNull(this.props.newRequestTicket.timeSavedEstimate)}
    //                             onChange={e => this.props.onChange(e)} />
    //                     </Col>
    //                 </Row>
    //                 <Row>
    //                     <Col md={4}>Client Directed</Col>
    //                     <Col>
    //                         <Label className='mr-4'>Yes
    //                             <Input
    //                                 className='ml-2'
    //                                 type="radio"
    //                                 name="clientDirected"
    //                                 checked={this.props.isFieldNull(this.props.newRequestTicket.clientDirected)}
    //                                 value={true}
    //                                 onChange={e => this.props.onChange(e)} />
    //                         </Label>
    //                         <Label className='ml-4'>No
    //                             <Input
    //                                 className="ml-2"
    //                                 type="radio"
    //                                 name="clientDirected"
    //                                 checked={!this.props.isFieldNull(this.props.newRequestTicket.clientDirected)}
    //                                 value={false}
    //                                 onChange={e => this.props.onChange(e)} />
    //                         </Label>
    //                     </Col>
    //                 </Row>
    //                 <Row>
    //                     <Col md={4}></Col>
    //                     <Col className='font-italic'>
    //                         {this.props.newRequestTicket.clientDirected != null && this.props.newRequestTicket.clientDirected && <Label className='ml-1'>Customer has asked for this functionality</Label>}
    //                         {this.props.newRequestTicket.clientDirected != null && !this.props.newRequestTicket.clientDirected && <Label className='ml-1'>BO has asked for this to increase productivity and accuracy</Label>}
    //                     </Col>
    //                 </Row>
    //                 <Row>
    //                     <Col md={4}>Notes<br /><span className="pl-2">(specific details of request)</span></Col>
    //                     <Col>
    //                         <Input
    //                             type="textarea"
    //                             rows={6}
    //                             name="notes"
    //                             value={this.props.isFieldNull(this.props.newRequestTicket.notes)}
    //                             onChange={e => this.props.onChange(e)} />
    //                     </Col>
    //                 </Row>
    //             </Col>
    //             <Col md={4} className="text-right">
    //                 <Button
    //                     disabled={parseInt(this.props.newRequestTicket.employeeId) === 0 ||
    //                         parseInt(this.props.newRequestTicket.teamId) === 0 ||
    //                         parseInt(this.props.newRequestTicket.clientId) === 0 ||
    //                         parseInt(this.props.newRequestTicket.requestId) === 0
    //                     }
    //                     color="primary"
    //                     onClick={this.props.handleAdd}
    //                 >Add Request Ticket</Button>
    //             </Col>
    //         </Row >
    //     </td></tr>
    //     )
    // }

    enableDrag = (content, dragProps) => {
        if (this.props.selectedSortColumnIndex === 8) {
            return (<ReactDragListView.DragColumn {...dragProps}>
                {content}
            </ReactDragListView.DragColumn>
            )
        } else {
            return content
        }
    }

    render() {
        this.props.info('BOTManagementForm.js/render');
        const dragProps = {
            onDragEnd: (fromIndex, toIndex) => {
                const data = [...this.props.botRequestTickets];
                const item = data.splice(fromIndex, 1)[0];
                data.splice(toIndex, 0, item);
                this.props.reorder(data, true, toIndex);
            },
            nodeSelector: 'tr.bot',
            handleSelector: 'tr.bot',
        };
        return (<>
            {this.enableDrag(
                <Table className={"adminContainer " + (this.props.singleEmployee ? " wraptable" : "")}>
                    {this.props.botRequestTickets.length > 0 && <thead>
                        <tr className="adminRow font-weight-bold widgetRow text-left">
                            {this.props.columns
                                .filter(col => (this.props.singleEmployee == null || !this.props.singleEmployee) || (this.props.singleEmployee && (!col.singleEmployeeHide || col.singleEmployeeHide == null)))
                                .map((col, colIndex) => (
                                    <th key={col.name} onClick={() => this.props.handleSort(colIndex)} className={col.sort !== false && ((this.props.singleEmployee == null || !this.props.singleEmployee)) ? 'pointer' : ''}>
                                        {col.name}
                                        {(this.props.singleEmployee == null || !this.props.singleEmployee) && <span className={"chevron mr-2 " + (colIndex === this.props.selectedSortColumnIndex ? "text-info" : "text-white")}><FontAwesomeIcon icon={this.props.selectedSortAscending ? faChevronUp : faChevronDown} /></span>}
                                    </th>
                                ))}
                        </tr>
                    </thead>}
                    <tbody>
                        {this.props.botRequestTickets.map(botRequestTicket => (
                            <Fragment key={botRequestTicket.id}>{this.props.botRequestTicketId === botRequestTicket.id ? this.editRow(botRequestTicket) : this.standardRow(botRequestTicket)}</Fragment>
                        ))}
                        {/* {this.props.addNew !== false && <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Request Tickets">
                            {this.addRow()}
                        </PermissionWrapper>} */}
                    </tbody>
                </Table>, dragProps)}
        </>
        );

    }
}

export default BOTManagementForm;
